import { render, staticRenderFns } from "./SegmentInfo.vue?vue&type=template&id=47e60873&scoped=true"
import script from "./SegmentInfo.vue?vue&type=script&lang=js"
export * from "./SegmentInfo.vue?vue&type=script&lang=js"
import style0 from "./SegmentInfo.vue?vue&type=style&index=0&id=47e60873&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e60873",
  null
  
)

export default component.exports